import { render, staticRenderFns } from "./ComplianceByWilaya.vue?vue&type=template&id=1f37bffa"
import script from "./ComplianceByWilaya.vue?vue&type=script&lang=js"
export * from "./ComplianceByWilaya.vue?vue&type=script&lang=js"
import style0 from "./ComplianceByWilaya.vue?vue&type=style&index=0&id=1f37bffa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports